import HttpFactory from "~/repository/factory";
import { createPublicRequestConfig } from "~/repository/authSession";
import type { RecaptchaInput } from "~/types/auth";
import type {
  StoreFilters,
  StoreFulfillmentInput,
  StoreOrder,
  StorePage,
} from "~/types/schoolStore";

export interface StoreMaintenanceLoginResponse {
  access: string;
  refresh: string;
  organization: { id: number; slug: string; school_name: string };
  permissions: { "store.orders.view": boolean; "store.orders.manage": boolean };
  next_path: string;
}

export default class StoreMaintenanceModule extends HttpFactory {
  login(data: {
    organization_slug: string;
    username: string;
    password: string;
    recaptcha: RecaptchaInput;
  }) {
    return this.post<StoreMaintenanceLoginResponse>(
      "/api/accounts/store-maintenance/login/",
      data,
      createPublicRequestConfig(),
    );
  }

  refresh(refresh: string) {
    return this.post<{ access: string }>(
      "/api/accounts/store-maintenance/refresh/",
      { refresh },
      createPublicRequestConfig(),
    );
  }

  private config(access: string) {
    return createPublicRequestConfig({
      headers: { Authorization: `JWT ${access}` },
      suppressAuthFailureRedirect: true,
    });
  }

  listOrders(access: string, filters: StoreFilters = {}) {
    return this.get<StorePage<StoreOrder>>(
      "/api/commerce/maintenance/orders/",
      filters,
      this.config(access),
    );
  }

  getOrder(access: string, id: string) {
    return this.get<StoreOrder>(
      `/api/commerce/maintenance/orders/${encodeURIComponent(id)}/`,
      {},
      this.config(access),
    );
  }

  fulfillOrder(access: string, id: string, data: StoreFulfillmentInput) {
    return this.patch<StoreOrder>(
      `/api/commerce/maintenance/orders/${encodeURIComponent(id)}/fulfillment/`,
      data,
      this.config(access),
    );
  }
}
